import { ContextResponse } from '@serievo/contracts';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from './client';

export function useContextQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['context'],
    queryFn: ({ signal }) => apiGet('/context', ContextResponse, { signal }),
    select: (r) => r.data.tenants,
    enabled,
    staleTime: 5 * 60_000,
  });
}
